import { getAuth } from 'firebase/auth';

const getUserAuthData = () => getAuth().currentUser.getIdTokenResult(true);

export default getUserAuthData;
